import produce from 'immer';
import { TOGGLE_Special_FILTER_MENU } from './constants';

export const initialState = {
  specialFilterMenuStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const SpecialReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_Special_FILTER_MENU:
        draft.specialFilterMenuStatus = action.value;
        break;
      default:
        break;
    }
  });

export default SpecialReducer;
